export const hostRedirect = {
  "hatch-dev.mybigcommerce.com": { isStore: true },
  "academy.hatchembroidery.com": { isAcademy3: true },
  "projects.hatchembroidery.com": { isBlog: true },
  "community.hatchembroidery.com": { isCommunity: true },
};

export const signOutUrl = {
  store: "https://hatch-dev.mybigcommerce.com/login.php?action=logout",
  academy3: "https://academy.hatchembroidery.com/users/sign_out",
  dnn: "http://13.238.162.168/Home/tabid/56/ctl/Logoff/language/en-US/Default.aspx",
};

export const landingPage = {
  store: "https://hatch-dev.mybigcommerce.com",
  academy3: "https://academy.hatchembroidery.com",
  community: "https://community.hatchembroidery.com",
  blog: "https://projects.hatchembroidery.com",
};
